import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "position-absolute",
  style: {"top":"24px","right":"24px"}
}
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = {
  class: "position-absolute",
  style: {"bottom":"16px","left":"16px"}
}
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-2" }

import { useAuthStore } from '../store'
import { ref, computed } from 'vue'
import { useThemeStore } from '@/stores/theme'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const themeStore = useThemeStore()
const currentTheme = computed(() => themeStore.currentTheme)
const authStore = useAuthStore()

const email = ref<string>('')
const password = ref<string>('')
const rememberMe = ref<boolean>(false)
const showPassword = ref<boolean>(false)

const isLoading = ref<boolean>(false)
const isSignInDisabled = ref<boolean>(false)

const error = ref<boolean>(false)
const errorMessages = ref<string>('')
const errorProvider = ref<boolean>(false)
const errorProviderMessages = ref<string>('')

const errorPassLogin = computed(() => authStore.errorPassLogin)
const errorPassLoginMsg = computed(() => authStore.errorPassLoginMsg)
const errorLoginMsg = computed(() => authStore.errorLoginMsg)

async function btnSubmit(): void {
  if (email.value && password.value) {
    isLoading.value = true
    isSignInDisabled.value = true
    await authStore.signIn({ email: email.value, password: password.value })
    isLoading.value = false
    isSignInDisabled.value = false
  }
}

function resetErrors(): void {
  error.value = false
  errorMessages.value = ''

  errorProvider.value = false
  errorProviderMessages.value = ''
}

function btnToggleTheme(): void {
  themeStore.toggleTheme()
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "fill-height pa-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "fill-height"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8",
            class: "bg-background position-relative d-flex align-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: btnToggleTheme
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(currentTheme.value === 'myCustomDarkTheme' ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_container, {
                class: "d-flex flex-column justify-center",
                style: {"max-width":"900px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "fill-height flex-grow-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            variant: "flat",
                            class: "pa-8",
                            width: "100%",
                            style: {"max-width":"400px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_avatar, {
                                color: "primary",
                                rounded: "",
                                size: "44",
                                class: "mb-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { color: "white" }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                      _createTextVNode("mdi-file-document-outline")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-subtitle-1 mb-1 font-weight-medium" }, "Nuevo crecimiento", -1)),
                              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex align-center" }, [
                                _createElementVNode("span", { class: "text-h4 font-weight-bold" }, "862"),
                                _createElementVNode("span", { class: "text-caption font-weight-medium text-success ml-2" }, "+22%")
                              ], -1)),
                              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-caption mt-1" }, "Mensual", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("img", {
                            src: "/isowipi.svg",
                            alt: "Character",
                            height: "400"
                          }, null, -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "4",
                        class: "d-flex flex-column justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            variant: "flat",
                            class: "rounded-lg pa-4 mb-4",
                            "min-height": "80px"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", null, [
                                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-subtitle-1 mb-1 font-weight-medium" }, "Nuevas racies", -1)),
                                  _createElementVNode("div", _hoisted_3, [
                                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-h4 font-weight-bold" }, "344", -1)),
                                    _createVNode(_component_v_icon, {
                                      color: "success",
                                      size: "small",
                                      class: "mx-1"
                                    }, {
                                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                                        _createTextVNode("mdi-arrow-up")
                                      ])),
                                      _: 1
                                    }),
                                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-caption font-weight-medium text-success" }, "18.2%", -1))
                                  ])
                                ]),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_avatar, {
                                  color: "amber-lighten-5",
                                  size: "44"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { color: "warning" }, {
                                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                                        _createTextVNode("mdi-chart-line")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card, {
                            variant: "flat",
                            class: "rounded-lg pa-4",
                            "min-height": "100px"
                          }, {
                            default: _withCtx(() => [
                              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-h5 font-weight-bold mb-2" }, "+ 5", -1)),
                              _createVNode(_component_v_icon, {
                                color: "success",
                                size: "small",
                                class: "mx-1"
                              }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("mdi-image")
                                ])),
                                _: 1
                              }),
                              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-subtitle-1 font-weight-medium" }, "Mediciones", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_img, {
                      src: "/isowipi.svg",
                      alt: "Decoration"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "4",
            class: "login-wrapper d-flex align-center justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                variant: "flat",
                class: "pa-8",
                width: "100%",
                "max-width": "400"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    contain: "",
                    height: "130px",
                    src: "/wipilogo.svg",
                    class: "mb-6"
                  }),
                  _cache[21] || (_cache[21] = _createElementVNode("h1", { class: "text-h4 font-weight-bold mb-2" }, "Bienvenido! 👋", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-body-1 text-medium-emphasis mb-6" }, "Porfavor, ingrese con su cuenta de Torcaza.", -1)),
                  _createVNode(_component_v_sheet, {
                    color: "purple-lighten-5",
                    class: "rounded-lg pa-4 mb-8"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createElementVNode("div", { class: "text-body-2" }, [
                        _createElementVNode("span", { class: "font-weight-medium" }, "Novedades:"),
                        _createElementVNode("span", { class: "text-primary font-weight-medium" }, " Nuevo módulo de exportación")
                      ], -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_form, {
                    onSubmit: _withModifiers(btnSubmit, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-sm text-body ms-1 font-weight-medium" }, "EMAIL", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: email.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                          error: error.value,
                          name: "email",
                          variant: "outlined",
                          "prepend-inner-icon": "mdi-email-outline",
                          placeholder: "johndode@wipitech.com",
                          "bg-color": "bg-primary",
                          onChange: resetErrors
                        }, null, 8, ["modelValue", "error"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-sm text-body ms-1 font-weight-medium" }, "PASSWORD", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: password.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                          "append-inner-icon": showPassword.value ? 'mdi-eye' : 'mdi-eye-off',
                          type: showPassword.value ? 'text' : 'password',
                          error: error.value,
                          "error-messages": errorMessages.value,
                          name: "password",
                          variant: "outlined",
                          "prepend-inner-icon": "mdi-lock-outline",
                          placeholder: "••••••",
                          "bg-color": "bg-primary",
                          onChange: resetErrors,
                          "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
                        }, null, 8, ["modelValue", "append-inner-icon", "type", "error", "error-messages"])
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "d-flex justify-space-between align-center mb-6" }, null, -1)),
                      (errorLoginMsg.value)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "error",
                            class: "my-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(errorLoginMsg.value), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        type: "submit",
                        color: "primary",
                        block: "",
                        size: "large",
                        loading: isLoading.value,
                        disabled: isSignInDisabled.value,
                        class: "text-none mb-6",
                        onClick: btnSubmit
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode(" Login ")
                        ])),
                        _: 1
                      }, 8, ["loading", "disabled"]),
                      (errorPassLogin.value)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 1,
                            border: "right",
                            "colored-border": "",
                            type: "error",
                            elevation: "2",
                            class: "mt-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(errorPassLoginMsg.value), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})